module.exports = __webpack_public_path__ + "img/card-contract-document-configuration-hover.af67eb14.svg";